"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransform = exports.dotRootContainerStyles = void 0;
require("./dotStyles.css");
const dotRootContainerStyles = "cds-dotRootContainerStyles-d11itni5";
exports.dotRootContainerStyles = dotRootContainerStyles;
const getTransform = (pin, overlap) => {
  if (pin === undefined) {
    return {};
  }

  // splits string based on dash. (i.e top-right -> [top, right])
  const directions = pin.split('-');

  // If placement is incorrectly formatted, then return empty array
  if (directions.length !== 2) return {};
  const vertical = directions[0],
    horizontal = directions[1];
  const transformedHorizontal = horizontal === 'start' ? 'left' : 'right';
  const verticalMultiplier = vertical === 'bottom' ? 1 : -1;
  const horizontalMultiplier = horizontal === 'end' ? 1 : -1;

  // If the content we are overlapping has a circular shape
  // we need to apply more transformation to the dot
  // so it sits on the circle rather than awkwardly outside
  // inspiration: https://mui.com/material-ui/react-badge/#badge-overlap
  // 14% because that is what yields the best result :p
  const amountToShift = overlap === 'circular' ? '14%' : 0;
  return {
    position: 'absolute',
    [transformedHorizontal]: amountToShift,
    [vertical]: amountToShift,
    transform: `translate(${horizontalMultiplier * 50}%, ${verticalMultiplier * 50}%)`,
    // for DotCount because transform will be overridden by motion styles
    translateX: `${horizontalMultiplier * 50}%`,
    translateY: `${verticalMultiplier * 50}%`
  };
};
exports.getTransform = getTransform;